/**
 * Имена событий под руку: в коде обращаемся через константу, а не строкой,
 * чтобы опечатку ловил компилятор, а поиск по названию находил все места.
 */
export const ANALYTICS_EVENTS = {
    pageViewed: 'page_viewed',
    landingCtaClicked: 'landing_cta_clicked',
    loginStarted: 'login_started',
    signedIn: 'signed_in',
    signedUp: 'signed_up',
    signedOut: 'signed_out',
    onboardingCompleted: 'onboarding_completed',
    onboardingFailed: 'onboarding_failed',
    testStarted: 'test_started',
    testProgress: 'test_progress',
    testCompleted: 'test_completed',
    testFailed: 'test_failed',
    resultViewed: 'result_viewed',
    resultEmpty: 'result_empty',
    inviteCreated: 'invite_created',
    inviteLinkCopied: 'invite_link_copied',
    inviteShared: 'invite_shared',
    invitesViewed: 'invites_viewed',
    inviteAcceptConfirmed: 'invite_accept_confirmed',
    matchesViewed: 'matches_viewed',
    matchesLocked: 'matches_locked',
    pairReportViewed: 'pair_report_viewed',
    pairReportFailed: 'pair_report_failed',
    pairNeedsOwnTest: 'pair_needs_own_test',
    paywallViewed: 'paywall_viewed',
    checkoutStarted: 'checkout_started',
    checkoutFailed: 'checkout_failed',
    manualCheckoutStarted: 'manual_checkout_started',
    paymentLinkOpened: 'payment_link_opened',
    paymentOutcomeSeen: 'payment_outcome_seen',
    reportPdfDownloaded: 'report_pdf_downloaded',
    reportPdfShared: 'report_pdf_shared',
    pushPermissionAsked: 'push_permission_asked',
    pushNotificationOpened: 'push_notification_opened',
    accountDeleted: 'account_deleted',
    localeChanged: 'locale_changed',
    adminReportOpened: 'admin_report_opened',
};
/**
 * Словарь полезен, только пока он полон: у события, описанного в
 * `AnalyticsEventProps`, но забытого в `ANALYTICS_EVENTS`, тип справа станет
 * именем этого события, и присваивание `true` не пройдёт сборку. Само значение
 * никому не нужно — экспорт лишь удерживает проверку в коде.
 */
export const ANALYTICS_DICTIONARY_IS_COMPLETE = true;
//# sourceMappingURL=analytics.js.map